import React, { Component } from 'react';
import { Form, Modal } from 'antd';

import UploadFile from '@comm/upload/UploadFile';
import { queryDownloadClueTemplate } from '@api/crm/crm';

const FormItem = Form.Item;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    let fileUuid = '';
    if (this.state.licenseFile && this.state.licenseFile.length > 0) {
      fileUuid = this.state.licenseFile[0].uuid;
    }
    const { handleSubmit } = this.props;
    this.props.form.validateFields(err => {
      if (!err) {
        handleSubmit({ fileUuid });
      }
    });
  };

  handlelicenseFile = fileList => {
    this.setState({
      licenseFile: fileList,
    });
  };

  render() {
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const date = new Date();
    const year = date.getFullYear();
    const years = [];
    for (let i = year; i >= 2014; i--) {
      years.push(i.toString());
    }
    return (
      <Modal title="导入" visible onOk={this.submit} onCancel={() => this.props.cancel(false)}>
        <Form layout="horizontal">
          <FormItem label="上传Excel文件" {...formItemLayout} required>
            <UploadFile type="ghost" handleUpload={this.handlelicenseFile} isExcel />
            <span className="ant-form-text">
              &nbsp;仅限excel格式
              <a onClick={() => queryDownloadClueTemplate()} style={{ marginLeft: '10px' }}>
                模板下载
              </a>
            </span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(DetailModal);



// WEBPACK FOOTER //
// ./src/components/crm/thread/ModalImport.js